/**
 * 计算器路由自动生成
 * 根据注册中心 CALC_REGISTRY 自动生成 CalcPage 的子路由
 * - calc_mode='local' / 'api' → 使用 CalcShell 通用渲染器
 * - calc_mode='component' → 使用注册的独立组件
 */
import { CALC_REGISTRY } from './registry/calc_registry';
import CalcShell from './CalcShell.vue';

export function generateCalcRoutes() {
	const listRoute = {
		path: '/',
		name: 'CalcListPage',
		component: () => import('@/views/CalcListPage.vue'),
		meta: {
			keepAlive: false,
			title: '工程费用计算器',
			description: '20+种工程独立费免费在线计算器，涵盖监理费、设计费、招标代理费、造价咨询费、环评费、水保费等，依据国家及地方现行标准，输入数据秒出结果。'
		}
	};

	const calcRoutes = CALC_REGISTRY.map(calc => {
		const isShell = calc.calc_mode === 'local' || calc.calc_mode === 'api';
		return {
			path: calc.path,
			name: 'Calc_' + calc.id,
			component: isShell ? CalcShell : calc.component,
			meta: {
				keepAlive: false,
				title: calc.seo?.title || calc.name,
				description: calc.seo?.description || '',
			},
		};
	});

	return [listRoute, ...calcRoutes];
}
